<template>
  <div
    class="guarantee-item"
    v-for="guarantee in guaranteeText"
    :key="guarantee.id"
  >
    <div class="border">
      {{ guarantee }}
    </div>
  </div>
</template>

<script>
export default {
  name: "main-guarantee-item",
  props: {
    guaranteeText: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.guarantee-item {
  position: relative;
  width: 205px;
  height: 44px;
  font-size: 14px;
  display: flex;
  box-sizing: border-box;

  @media (max-width: 767px) {
    width: 107px;
    height: 38px;
    font-size: 7px;
  }

  .bg-white {
    padding: 0 20px;
    box-sizing: border-box;
  }
}

.border {
  width: 192px;
  background-size: contain !important;
  background: url("@/assets/images/border-white-small.png") no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: break-spaces;
  box-sizing: border-box;
  text-align: center;
  font-family: "UAF Sans HR", serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;

  @media (max-width: 767px) {
    font-size: 7px;
    height: unset;
    width: 106px;
    line-height: 13px;
  }

  @media (min-width: 768px) {
    height: 70px !important;
  }
}
</style>
